import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { locationConstant } from '../constants/constant';
import { translate } from '../i18n';

interface ILocation {
  locationName: string;
  OwnerId: number;
  defaultLat: number;
  defaultLon: number;
}

interface LocationState {
  selectedLocation: ILocation;
  isUserSelected: boolean;
  setSelectedLocation: (location: ILocation, userSelected?: boolean) => void;
  resetLocation: () => void;
  clearLocationStore: () => void;
}

const defaultLocation: ILocation = {
  locationName: translate(`passengerManifest.portDuglasLocation`),
  OwnerId: locationConstant.ownerId,
  defaultLat: locationConstant.defaultLat,
  defaultLon: locationConstant.defaultLon,
};

const useLocationStore = create<LocationState>()(
  persist(
    (set) => ({
      selectedLocation: defaultLocation,
      isUserSelected: false,

      setSelectedLocation: (location, userSelected = true) =>
        set({
          selectedLocation: location,
          isUserSelected: userSelected,
        }),

      resetLocation: () =>
        set({
          selectedLocation: defaultLocation,
          isUserSelected: false,
        }),

      clearLocationStore: () =>
        set({
          selectedLocation: defaultLocation,
          isUserSelected: false,
        }),
    }),
    {
      name: 'location-storage',
      partialize: (state) => ({
        selectedLocation: state.selectedLocation,
        isUserSelected: state.isUserSelected,
      }),
    },
  ),
);

export default useLocationStore;
